<div>
  <div class="modal-header modal-header-text text-center">
    <h2 class="arb-medium-heading" id="alertModalLabel">WARNING</h2>
  </div>
  <div class="modal-body">
    <p class="alert-message">
      Australian privacy law requires you to inform the customer that their personal information may be shared between ARB Corporation Limited and/or
      its affiliated entities (ARB), and its corporate partners. The sole purpose for sharing your personal information is to facilitate the current
      transaction and any future related transactions. The customer’s personal information will not be used or shared for marketing purposes unless
      the customer has expressly consented to receive marketing material or communications. Further information on how ARB handles personal
      information can be found at
      <span class="px-2">
        <a href="https://store.arb.com.au/pages/privacy-policy-terms-of-use/" target="_blank"> ARB Privacy Policy and Disclaimer – ARB 4X4 Accessories</a>.
      </span>
      Strict compliance with this policy is necessary to protect the personal information collected and held by ARB, and ARB reserves the right to
      take all reasonable and necessary action, including disciplinary action against any person/s failing to comply with the ARB Privacy Policy, to
      enforce this policy and to protect the personal information held by ARB
    </p>
    <p class="alert-message"></p>
  </div>
  <div class="modal-footer text-center">
    <div>
      <button (click)="onOtherButton()" class="btn btn-danger text-white">OKAY</button>
    </div>
  </div>
</div>
